import { RouteConfig } from 'vue-router';

// Vehicle Tracking components
const VehicleTrackingIndex = () => import(/* webpackChunkName: "vehicle-tracking-group" */ '@/pages/vehicle-tracking/VehicleTrackingIndex.vue')

const SlidePage = () => import('@/pages/SlidePage.vue')
const UnderConstruction = () => import(/* webpackChunkName: "generic-pages-group" */'@/pages/UnderConstruction.vue');

const routes: RouteConfig = {
  path: '/vehicle-tracking',
  name: 'Vehicle Tracking',
  redirect: '/vehicle-tracking/',
  component: SlidePage,
  children: [
    {
      path: '/',
      component: VehicleTrackingIndex
    },
    {
      path: '*',
      name: 'Vehicle Tracking catch all',
      component: UnderConstruction
    }
  ]
};

export default routes;
